import moment from "moment";
import React, { useState } from "react";
import { Tab, Tabs as Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const ManageSupplier = () => {
  const [limit, setLimit] = useState(100);
  const [suppilerId, setSuppilerId] = useState("");
  const [mrrNumber, setMrrNumber] = useState("");
  const [search, setSearch] = useState("");
  const [searchr, setSearchr] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const {
    data: ManageSupplier,
    error,
    mutate,
  } = useSWR(
    `store/mrr/manageSupplier?page=${pageIndex}&limit=${limit}`,
    fetcher
  );

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    let search = "";
    let searchr = "";
    if (e.target.name == "search") {
      search = e.target.value;
    }

    if (e.target.name == "searchr") {
      searchr = e.target.value;
    }

    //console.log(search);
    setSearch(search);
    setSearchr(searchr);
    let limit = search === "" || searchr === "" ? 10 : 1000;
    const res = await API.get(
      `store/mrr/manageSupplier?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
          searchr: `%${searchr}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate({ recentMonthSupply: [], suppliersWithEntriesInfo: [] }, false);
    }
  };
  const navigate = useNavigate();

  const handleSearchMRR = () => {
    if (suppilerId && parseInt(mrrNumber)) {
      API.get(
        `store/mrr/productReceptBySupIdMrr/${suppilerId}/${mrrNumber}`
      ).then((res) => {
        if (!res.data.error) {
          if (res.data.data === null) {
            swal({
              title: "Warning !",
              text: `${res.data.message}`,
              icon: "warning",
              button: "Ok",
            });
          } else {
            navigate(`/manageSupplier/addMoreMrr/${suppilerId}&${mrrNumber}`);
          }
        } else {
          swal({
            title: "Opps !",
            text: `${res.data.message}`,
            icon: "warning",
            button: "Ok",
          });
        }
      });
    } else {
      alert("Please Enter Supplier and Mrr Number");
    }
  };
  // handle supplier select;
  const handleSupplier = (name) => {
    setSuppilerId(name.value);
  };
  const { data: supplierOption, error: error1 } = useSWR(
    `store/settings/suppliers?page=${0}&limit=${10000}`,
    fetcher
  );

  // set supplier category select list
  let supplierCategory = [];
  if (supplierOption && supplierOption.length > 0) {
    supplierCategory = supplierOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.sup_id;
      optionsItem.label = `${data.supplier}`;
      return optionsItem;
    });
  }

  return (
    <>
      <Helmet>
        <title>(MRR) - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Supplier Wise Material Receiving Report(MRR)
            </h3>
          </div>

          {/* Search Tab */}
          <div style={{ background: "white" }} className="p-3">
            <Container
              defaultActiveKey="home"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="home" title="MRR Details">
                <div className="category show">
                  {!ManageSupplier ? (
                    <NotFoundPage />
                  ) : (
                    <div className="mx-auto">
                      {/* Search Result */}
                      <div
                        style={{ background: "white", borderRadius: "10px" }}
                      >
                        <div className="d-flex justify-content-between align-items-center search-div">
                          <div className="col-12 col-md-4 col-lg-4">
                            <p className="text-start mt-4 fs-6 text-black-50">
                              Show Entries
                              <select
                                onClick={(e) => {
                                  setLimit(parseInt(e.target.value));
                                }}
                                className="ms-2 btn-outline-color "
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </p>
                          </div>
                          <div className="col-12 col-md-4 col-lg-4">
                            <input
                              className="p-2 input-field w-100"
                              type="text"
                              name="search"
                              onChange={(e) => handleSearch(e)}
                              placeholder="Search"
                            />
                          </div>
                        </div>
                        <div className="table-responsive-sm data-table">
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr className="tableColor">
                                <th colSpan="1">S/N</th>
                                <th colSpan="1">SUPPLIER</th>
                                <th colSpan="1">QUANTITIES</th>
                                <th colSpan="1">TOTAL AMOUNT</th>
                                <th colSpan="1">ACTION</th>
                              </tr>
                            </thead>
                            {ManageSupplier.suppliersWithEntriesInfo && (
                              <tbody>
                                {ManageSupplier.suppliersWithEntriesInfo.map(
                                  (product, index) => (
                                    <tr className="lh-lg" key={index}>
                                      <th className="text-center" colSpan="1">
                                        {index + 1}
                                      </th>
                                      <td colSpan="1">{product.SUPPLIER}</td>
                                      <td colSpan="1">
                                        {product.Total_Quantity}
                                      </td>
                                      <td colSpan="1">
                                        {parseFloat(
                                          product.Total_Amount
                                        ).toFixed(2)}{" "}
                                      </td>
                                      <td colSpan="1" className="text-center">
                                        <Link
                                          to={`/MrrProductReceipt/${product.SUP_ID}`}
                                        >
                                          <button
                                            data-bs-toggle="tooltip"
                                            title="Edit"
                                            type="button"
                                            className="btn btn-success px-3 me-2"
                                          >
                                            <i class="fa-solid fa-newspaper"></i>
                                          </button>
                                        </Link>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            )}
                          </table>
                          {search.length > 0 ? (
                            <div></div>
                          ) : (
                            <div className="text-end mt-4 mb-3">
                              {pageIndex > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-color_store px-4 me-2"
                                  onClick={() => setPageIndex(pageIndex - 1)}
                                >
                                  Previous
                                </button>
                              )}

                              {ManageSupplier.suppliersWithEntriesInfo &&
                                (ManageSupplier.suppliersWithEntriesInfo
                                  .length === limit ? (
                                  <button
                                    type="button"
                                    className="btn btn-outline-color_store px-4 me-2"
                                    onClick={() => setPageIndex(pageIndex + 1)}
                                  >
                                    Next
                                  </button>
                                ) : (
                                  ""
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Tab>
              <Tab eventKey="profile" title="Recent MRR">
                <div className="category show">
                  {!ManageSupplier ? (
                    <NotFoundPage />
                  ) : (
                    <div className="mx-auto">
                      {/* Search Result */}

                      <div
                        style={{ background: "white", borderRadius: "10px" }}
                      >
                        <div className="d-flex justify-content-between align-items-center search-div">
                          <div className="col-12 col-md-4 col-lg-4">
                            <p className="text-start mt-4 fs-6 text-black-50">
                              Show Entries :
                              <select
                                onClick={(e) => {
                                  setLimit(parseInt(e.target.value));
                                }}
                                className="ms-2 btn-outline-color "
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </p>
                          </div>
                          <div className="col-12 col-md-4 col-lg-4">
                            <input
                              className=" p-2 input-field-new w-100"
                              type="text"
                              name="searchr"
                              onChange={(e) => handleSearch(e)}
                              placeholder="Search"
                            />
                          </div>
                        </div>
                        <div className="table-responsive-sm data-table">
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr className="tableColor">
                                <th colSpan="1">S/N</th>
                                <th colSpan="1">ENTRY DATE</th>
                                <th colSpan="1">MRR NO</th>
                                <th colSpan="1">SUPPLIER</th>
                                <th colSpan="1">ACTION</th>
                              </tr>
                            </thead>
                            {ManageSupplier.recentMonthSupply && (
                              <tbody>
                                {ManageSupplier.recentMonthSupply.map(
                                  (product, index) => (
                                    <tr className="lh-lg" key={index}>
                                      <th className="text-center" colSpan="1">
                                        {index + 1}
                                      </th>
                                      <td colSpan="1">
                                        {moment(
                                          new Date(product.ENTRIDATE)
                                        ).format("DD-MM-YYYY")}
                                      </td>
                                      <td colSpan="1">{product.MRRNNO} </td>
                                      <td colSpan="1">{product.SUPPLIER} </td>
                                      <td colSpan="1" className="text-center">
                                        <Link
                                          to={`/viewproductreceipt/${product.MRRNNO}&${product.SUP_ID}&${product.ENTRIDATE}`}
                                        >
                                          {" "}
                                          <button
                                            data-bs-toggle="tooltip"
                                            title="Edit"
                                            type="button"
                                            className="btn btn-primary px-3 me-2"
                                          >
                                            <i class="fa-solid fa-eye"></i>
                                          </button>
                                        </Link>
                                        <Link
                                          to={`/manageSupplier/addMoreMrr/${product.SUP_ID}&${product.MRRNNO}`}
                                        >
                                          {" "}
                                          <button
                                            data-bs-toggle="tooltip"
                                            title="Edit"
                                            type="button"
                                            className="btn btn-warning  px-3 me-2"
                                          >
                                            <i class="fa-solid fa-plus text-white"></i>
                                          </button>
                                        </Link>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            )}
                          </table>
                          {searchr.length > 0 ? (
                            <div></div>
                          ) : (
                            <div className="text-end mt-4 mb-3">
                              {pageIndex > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-color_store px-4 me-2"
                                  onClick={() => setPageIndex(pageIndex - 1)}
                                >
                                  Previous
                                </button>
                              )}

                              {ManageSupplier.recentMonthSupply &&
                                (ManageSupplier.recentMonthSupply.length ===
                                limit ? (
                                  <button
                                    type="button"
                                    className="btn btn-outline-color_store px-4 me-2"
                                    onClick={() => setPageIndex(pageIndex + 1)}
                                  >
                                    Next
                                  </button>
                                ) : (
                                  ""
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Tab>
              <Tab eventKey="addMore" title="Add More Existing MRR">
                <div className="category show">
                  {!ManageSupplier ? (
                    <NotFoundPage />
                  ) : (
                    <div className="mx-auto">
                      {/* Search Result */}

                      <div
                        style={{ background: "white", borderRadius: "10px" }}
                      >
                        <div className="row gx-5">
                          <div className="col-sm-6">
                            <label htmlFor="Supplier">
                              Supplier <span className="color-red">*</span>
                            </label>

                            <Select
                              onChange={handleSupplier}
                              style={{ borderRadius: "10px" }}
                              className="text-start"
                              options={supplierCategory}
                            />
                            <input
                              tabIndex={-1}
                              autoComplete="off"
                              style={{ opacity: 0, height: 0 }}
                              value={suppilerId}
                            />
                          </div>

                          <div className="col-sm-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              MRR Number <span className="color-red">*</span>
                            </label>
                            <input
                              onChange={(e) => setMrrNumber(e.target.value)}
                              placeholder="Enter MRR Number "
                              type="number"
                              className="p-2 form-control  input_field_category_store"
                              id="exampleFormControlInput1"
                              required
                            />
                          </div>
                        </div>
                        <div className="text-center mt-5">
                          <button
                            onClick={handleSearchMRR}
                            type="button"
                            className="mt-3 px-5 btn btn-color_store"
                          >
                            <i className="fa fa-search"></i>
                            <span> Search</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Tab>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageSupplier;
